import { Box, Typography } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import { useInput } from '../../../../../../customHook/useInput';
import zeplinColor from '../../../../../../theme/Color';
import CustomButton from '../../../../../shared/CustomButton/CustomButton';
import CustomCard from '../../../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../../../shared/CustomModal/CustomModal';
import CustomTab from '../../../../../shared/CustomTab/CustomTab';
import CustomTextField from '../../../../../shared/CustomTextField/CustomTextField';
import { Link } from 'react-router-dom';
import { getAuthUrl } from '../../../../../../utilities/CalendarUtils';

const CalendarMap = {
  google: 'Google Calendar',
  microsoft: 'Microsoft Teams',
  zoom: 'Zoom',
};

const CalendarAdd = ({
  handleClose,
  isModalOpen,
}: {
  handleClose: () => void;
  isModalOpen: boolean;
}) => {
  const {
    handleChange: handleNameChange,
    handleBlur: handleNameBlur,
    value: calendarName,
  } = useInput('', () => true);
  const [selectCalendar, setSelectCalendar] = useState('');
  const [value, setValue] = useState(0);
  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const AddCalendarTabs = [
    {
      label: 'Connect',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography variant='responsiveHeading4'>Connect a Calendar</Typography>
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral9}>
              Link a Google, Microsoft, or Zoom account to view and manage all events in one place.
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <CustomButton
              disabled={false}
              onClick={() => {
                setSelectCalendar(CalendarMap['google']);
              }}
              variant='outlined'
              color={'customSecondary'}
              style={{
                borderRadius: '16px',
                height: 56,
                padding: '16px',
                width: '100%',
                border: `1px solid ${
                  selectCalendar === CalendarMap['google']
                    ? zeplinColor.BasicBlack
                    : zeplinColor.Neutral6
                }`,

                '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
                flex: 1,
              }}
              textStyle={{
                color: zeplinColor.BasicBlack,
              }}
              text={CalendarMap['google']}
            />
            <CustomButton
              disabled={false}
              onClick={() => {
                setSelectCalendar(CalendarMap['zoom']);
              }}
              variant='outlined'
              color={'customSecondary'}
              style={{
                borderRadius: '16px',
                height: 56,
                padding: '16px',
                width: '100%',
                border: `1px solid ${
                  selectCalendar === CalendarMap['zoom']
                    ? zeplinColor.BasicBlack
                    : zeplinColor.Neutral6
                }`,
                '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
                flex: 1,
              }}
              textStyle={{
                color: zeplinColor.BasicBlack,
              }}
              text={CalendarMap['zoom']}
            />
            <CustomButton
              disabled={false}
              onClick={() => {
                setSelectCalendar(CalendarMap['microsoft']);
              }}
              variant='outlined'
              color={'customSecondary'}
              style={{
                borderRadius: '16px',
                height: 56,
                padding: '16px',
                width: '100%',
                border: `1px solid ${
                  selectCalendar === CalendarMap['microsoft']
                    ? zeplinColor.BasicBlack
                    : zeplinColor.Neutral6
                }`,
                '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
                flex: 1,
              }}
              textStyle={{
                color: zeplinColor.BasicBlack,
              }}
              text={CalendarMap['microsoft']}
            />
          </Box>
          <Link
            to={getAuthUrl(selectCalendar?.toLocaleLowerCase())}
            style={{ textDecoration: 'none' }}
            onClick={() => {
              sessionStorage.setItem('calendar-provider', selectCalendar?.toLocaleLowerCase());
              sessionStorage.setItem('calendar-connecting', 'true');
            }}
          >
            <CustomButton
              disabled={false}
              onClick={() => {}}
              variant='outlined'
              style={{
                borderRadius: '14px',
                height: 48,
                padding: '14px 16px',
                width: '100%',
                backgroundColor: selectCalendar ? zeplinColor.Brand1 : zeplinColor.Neutral5,
                border: `1px solid ${selectCalendar ? zeplinColor.Brand1 : zeplinColor.Neutral5}`,

                flex: 1,
              }}
              textStyle={{
                color: selectCalendar ? zeplinColor.Neutral1 : zeplinColor.Neutral8,
              }}
              text={'Connect Calendar'}
            />
          </Link>
        </Box>
      ),
    },
    // {
    //   label: 'Subscribe',
    //   id: 2,
    //   isHidden: value !== 1,
    //   Component: (
    //     <Box>
    //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
    //         <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    //           <Typography variant='responsiveHeading4'>Subscribe to a Calendar</Typography>
    //           <Typography variant='responsiveBody3' color={zeplinColor.Neutral9}>
    //             subscribe to an external calendar using an email address or iCal link.
    //           </Typography>
    //         </Box>
    //         <CustomTextField
    //           style={{ width: '100%' }}
    //           onBlur={handleNameBlur}
    //           onChange={handleNameChange}
    //           name='Enter email or URL'
    //           text={calendarName}
    //           form={true}
    //           error={false}
    //           label={'Enter email or URL'}
    //           type='text'
    //           tabindex={1}
    //         />
    //         <CustomButton
    //           disabled={false}
    //           onClick={() => {}}
    //           variant='outlined'
    //           style={{
    //             borderRadius: '14px',
    //             height: 48,
    //             padding: '14px 16px',
    //             width: '100%',
    //             backgroundColor: calendarName ? zeplinColor.Brand1 : zeplinColor.Neutral5,
    //             border: `1px solid ${calendarName ? zeplinColor.Brand1 : zeplinColor.Neutral5}`,

    //             flex: 1,
    //           }}
    //           textStyle={{
    //             color: calendarName ? zeplinColor.Neutral1 : zeplinColor.Neutral8,
    //           }}
    //           text={'Subscribe Calendar'}
    //         />
    //       </Box>
    //     </Box>
    //   ),
    // },
  ];
  return (
    <CustomModal handleClose={handleClose} open={isModalOpen}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: '397px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '18px', xl: '20px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                Add a Calendar
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                alt='close'
                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                onClick={handleClose}
              />
            </Box>
            <CustomTab tabs={AddCalendarTabs} handleChange={handleChange} value={value} />
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default CalendarAdd;
